import React from 'react'
import { observer } from 'mobx-react-lite'
import { ROUTES } from 'shared/config/routes'
import { ReportsShell } from '../../reports/components/ReportsShell'
import useParentNotification from './hooks/useParentNotification'
import Tabs from './components/Tabs/Tabs'
import Updates from './components/Updates/Updates'
import Contacts from './components/Contacts/Contacts'
import Logs from './components/Logs/Logs'
import ContactModal from './components/ContactModal/ContactModal'
import SummaryGrid from './components/SummaryGrid/SummaryGrid'

const ParentNotification = observer(() => {
	const vm = useParentNotification()

	return (
		<ReportsShell title="Parent communication" backTo={ROUTES.SETTINGS}>
			<Tabs tab={vm.tab} onTabChange={vm.setTab} />
			{vm.tab === 'updates' ? (
				<>
					<SummaryGrid activeCount={vm.activeCount} pausedCount={vm.pausedCount} />
					<Updates {...vm} />
				</>
			) : null}
			{vm.tab === 'contacts' ? <Contacts {...vm} /> : null}
			{vm.tab === 'logs' ? <Logs /> : null}
			{vm.contactDraft ? (
				<ContactModal
					key={`${vm.contactDraft.mode}-${vm.contactDraft.studentId}`}
					{...vm}
				/>
			) : null}
		</ReportsShell>
	)
})

export default ParentNotification
